export const APP_LOAD = 'APP_LOAD'; // 应用载入
export const LOAD_USER = 'LOAD_USER'; // 载入用户信息
export const UPDATE_LOADING = 'UPDATE_LOADING'; // 更新loading状态
export const LOGIN = 'LOGIN'; // 更新loading状态
export const LOGOUT = 'LOGOUT'; // 更新loading状态
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'; // 切换sidebar状态
export const SWITCH_TENANT = 'SWITCH_TENANT'; // 切换tenant
